var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRectWarningLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0969 4.48363L18.7171 12.486C20.086 14.8571 18.3749 17.8209 15.637 17.8209H6.39664C3.65876 17.8209 1.94758 14.8571 3.31652 12.486L7.93669 4.48363C9.30563 2.11256 12.728 2.11255 14.0969 4.48363ZM12.5569 5.37278C11.8724 4.18724 10.1612 4.18724 9.47675 5.37278L4.85658 13.3752C4.17211 14.5607 5.0277 16.0426 6.39664 16.0426H15.637C17.0059 16.0426 17.8615 14.5607 17.177 13.3752L12.5569 5.37278Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1277 12.4858H11.906V14.2641H10.1277V12.4858ZM10.1277 7.15088H11.906V11.5966H10.1277V7.15088Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectWarningLine);
export default __webpack_public_path__ + "static/media/rect-warning-line.43386a0ab3422f451f20729fe3f83966.svg";
export { ForwardRef as ReactComponent };